import { createApp } from 'vue';
import Project from './components/project/ProjectList.vue';

const app = createApp({
    components: {
        'project-component': Project
    },
    data() {
        return {
            'projects': Object,
            'unit_price_types': Array,
            'job_types_data': Array,
            'skills_data': Array,
            'industry_types_data': Array,
            'areas_data': Array,
            'condition_types_data': Array,
            'max_favorite_count': Number,
            'price_adjustments': Object,
            'contract_types': Object,
            'cookie_expires': Number,
            'project_sort_type': Object,
            'project_sort_type_name': Object,
            'paginate_link_num': Number,
            'search_category_code': Object,
            'condition': Object,
            'is_form_empty': Boolean,
            'cat_code': String,
            'cat_id': Number,
            'project_url': String
        }
    }
})

app.mount('#project')